import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import requester from "../../requester";

export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const response = await requester.get("");
  return response.data;
});

export const addJob = createAsyncThunk("jobs/addJob", async (job) => {
  const response = await requester.post("", job);
  return response.data;
});

export const updateJob = createAsyncThunk("jobs/updateJob", async (job) => {
  const response = await requester.put(`/${job.id}`, job);
  return response.data;
});

export const deleteJob = createAsyncThunk("jobs/deleteJob", async (id) => {
  const response = await requester.delete(`/${id}`);
  return response.data;
});

const initialState = {
  allJobs: [],
  editJob: null,
  error: null,
  filterBy: "",
};

const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filterBy = action.payload;
    },
    setEditJob: (state, action) => {
      const jobToEdit = state.allJobs.find((job) => job.id === action.payload);
      state.editJob = jobToEdit;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.error = null;
        state.allJobs = action.payload;
        state.editJob = null;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.allJobs = [];
        state.error = action.error.message;
        state.editJob = null;
      })
      .addCase(addJob.fulfilled, (state, action) => {
        state.allJobs.push(action.payload);
      })
      .addCase(updateJob.fulfilled, (state, action) => {
        const jobIndex = state.allJobs.findIndex(
          (job) => job.id === action.meta.arg.id
        );
        state.allJobs[jobIndex] = action.payload;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.allJobs = state.allJobs.filter(
          (job) => job.id !== action.meta.arg
        );
      });
  },
});

export const { setFilter, setEditJob } = jobsSlice.actions;

export default jobsSlice.reducer;
